import { render, staticRenderFns } from "./colorSelector.vue?vue&type=template&id=79508fef&scoped=true&"
import script from "./colorSelector.ts?vue&type=script&lang=ts&"
export * from "./colorSelector.ts?vue&type=script&lang=ts&"
import style0 from "./colorSelector.vue?vue&type=style&index=0&id=79508fef&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79508fef",
  null
  
)

export default component.exports